import {
    Component,
    EventEmitter,
    Inject,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
} from '@angular/core';
import { Style } from '../../@shared/models/style.model';
import { DOCUMENT } from '@angular/common';

@Component({
    selector: 'app-style-item-listing',
    templateUrl: './style-item-listing.component.html',
    styleUrls: ['./style-item-listing.component.scss'],
})
export class ListingCircleListingComponent implements OnChanges {
    @Input() style: Style = new Style();
    @Input() radius: 'small' | 'normal' | 'large' = 'small';
    @Input() margin = 0;
    @Input() hideTitle = false;
    @Input() activeTabColor = 'primary';

    @Output() processLink: EventEmitter<string> = new EventEmitter();

    private readonly STYLE_CSS_PREFIX = 'style-item-';
    private readonly HOVER_CSS_PREFIX = 'image-hover-';

    imageCSSClasses = '';
    textCSSClasses = '';
    imageLoaded = true;
    hoverImageClasses = '';
    imageActiveBorderClass = '';

    imageBorderClass = '';

    constructor(@Inject(DOCUMENT) document: Document) {}

    ngOnChanges(changes: SimpleChanges): void {
        this.hoverImageClasses = this.HOVER_CSS_PREFIX + this.radius;
        const activeTabClass =
            this.activeTabColor === 'black'
                ? 'style-item-image-active'
                : 'style-item-image-primary-active';
        const imageClasses = [
            this.STYLE_CSS_PREFIX + this.radius,
            this.style.active ? activeTabClass : 'style-item-image-inactive',
            this.style.active
                ? this.STYLE_CSS_PREFIX + this.radius + '__active'
                : '',
            this.hoverImageClasses,
        ];
        this.imageBorderClass =
            this.STYLE_CSS_PREFIX + this.radius + '__active';
        this.imageActiveBorderClass =
            this.STYLE_CSS_PREFIX + this.radius + '__active-border';
        this.imageCSSClasses = imageClasses.join(' ');

        const textClasses = [
            'style-item-text',
            this.STYLE_CSS_PREFIX + this.radius,
        ];
        this.textCSSClasses = textClasses.join(' ');
    }
    public missingImage(event: Event) {
        (event.target as HTMLImageElement).style.maxHeight = '60px';
        (event.target as HTMLImageElement).style.maxWidth = '60px';
        this.imageLoaded = false;
    }

    process(link: string) {
        this.processLink.emit(link);
    }
}
